import { useEffect, useRef, useCallback } from 'react'

export function useIdleTimer(timeoutMs, onIdle) {
  const timerRef  = useRef(null)
  const onIdleRef = useRef(onIdle)
  onIdleRef.current = onIdle

  const reset = useCallback(() => {
    clearTimeout(timerRef.current)
    timerRef.current = setTimeout(() => onIdleRef.current(), timeoutMs)
  }, [timeoutMs])

  useEffect(() => {
    const events = ['touchstart', 'touchmove', 'mousedown', 'mousemove', 'keydown', 'scroll']
    events.forEach((e) => window.addEventListener(e, reset, { passive: true }))
    reset()
    return () => {
      clearTimeout(timerRef.current)
      events.forEach((e) => window.removeEventListener(e, reset))
    }
  }, [reset])

  return reset
}
